import { makeReactQueryMethodCreator } from '@shared/api/utils';

import { del, get, patch, postWithAbort, put } from './superAgentMethods';

export * from './superAgentMethods';

export const methods = {
  get: makeReactQueryMethodCreator(get),
  post: makeReactQueryMethodCreator(postWithAbort),
  put: makeReactQueryMethodCreator(put),
  del: makeReactQueryMethodCreator(del),
  patch: makeReactQueryMethodCreator(patch),
};
